import Hero from '../components/Hero';
import Advantages from '../components/Advantages';
import Services from '../components/Services';
import WhoWeAre from '../components/WhoWeAre';
import Industries from '../components/Industries';
import CTASection from '../components/CTASection';
import VendorBand from '../components/VendorBand';

export default function Home() {
  return (
    <>
      <Hero />
      <Advantages />
      <div className="pt-24" />
      <WhoWeAre />
      <Services />
      <VendorBand />
      <Industries />
      <CTASection />
    </>
  );
}
